import styled from 'styled-components'

export const UserListSelected = styled.div`
  margin-bottom: 8px;

  .lable {
    font-weight: 500;
    margin-bottom: 6px;
  }

  .ant-tag {
    margin-bottom: 8px;
    padding: 5px 14px;
    border-radius: 25px;
    cursor: pointer;
  }

`
export const TitleModal = styled.div`
  display: flex;
  justify-content: space-between;
`